// extracted by mini-css-extract-plugin
export default {"parent":"box_parent__GCQDX","content":"box_content__E7UHy"};